<template>
    <div v-if="show" id="zb_cta-banner-v2_block_e78544d46ed0a71e290d07c2ab7330c2" class="bottom-fix-block zb-cta-banner-v2 zb-sticky-bottom zb-fullwidth" data-padding="20">

        <div class="zb-outer-container content-width content-full" style="background-color: #000000">
            <button @click.prevent="show = false" class="close-button light">⊗</button>		<div class="zb-container vertical-when-mobile">
            <div class="title">

                <p class="zb-text lg_txt-title-sm sm_txt-body-md text-align-inherit txt-bold has-focus-00-color">{{ text }}</p>

            </div>
            <div class="buttons">

                <a @click.prevent="to" href="" aria-label="Start now" data-schema="cta" data-destination="funnel" data-position="sticky" data-type="llc" class="zb-button txt-button-lg button-growth button-primary ">

                    Start now
                </a>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        url: String,
        text: String,
    },
    data() {
        return {
            show: true
        }
    },
    methods: {
        to() {
            this.$router.push({ path: this.url })
        }
    }
}
</script>
<style scoped>

p {
    display: block;
}
.bottom-fix-block {

}
/*! CSS Used from: https://www.zenbusiness.com/wp-content/themes/zenbusiness/assets/css/imports.css?ver=1685981523 ; media=all */
@media all{
    *{box-sizing:border-box;-webkit-font-smoothing:antialiased;-webkit-tap-highlight-color:rgba(0,0,0,0);}
    a,div,p{margin:0;padding:0;border:0;font-size:100%;font-family:inherit;font-weight:inherit;vertical-align:baseline;}
    a{text-decoration:none;font-size:inherit;color:#002FCF;}
    a:active{color:#002FCF;}
    a:focus,a:hover{color:#0226A6;}
    p{margin-bottom:15px;}
    .lg_txt-title-sm,.sm_txt-body-md,.txt-button-lg{font-family:"Inter","Trebuchet_MS",sans-serif;}
    .txt-button-lg{font-weight:600;}
    @media screen and (min-width:960px){
        .lg_txt-title-sm{font-weight:400;}
    }
    @media screen and (max-width:959px){
        .sm_txt-body-md{font-weight:400;}
    }
    .txt-bold{font-weight:600;}
    @media screen and (max-width:959px){
        .sm_txt-body-md{font-size:.9375rem;line-height:1.4375rem;}
        .txt-button-lg{font-size:1rem;line-height:1.25rem;}
    }
    @media screen and (min-width:960px){
        .lg_txt-title-sm{font-size:1.75rem;line-height:2.125rem;letter-spacing:-.5px;}
        .txt-button-lg{font-size:1.25rem;line-height:1.5rem;}
    }
    .text-align-inherit{text-align:inherit;}
    .lg_txt-title-sm,.sm_txt-body-md,.txt-button-lg{font-family:"Inter","Trebuchet_MS",sans-serif;}
    .txt-button-lg{font-weight:600;}
    @media screen and (min-width:960px){
        .lg_txt-title-sm{font-weight:400;}
    }
    @media screen and (max-width:959px){
        .sm_txt-body-md{font-weight:400;}
    }
    .txt-bold{font-weight:600;}
    @media screen and (max-width:959px){
        .sm_txt-body-md{font-size:.9375rem;line-height:1.4375rem;}
        .txt-button-lg{font-size:1rem;line-height:1.25rem;}
    }
    @media screen and (min-width:960px){
        .lg_txt-title-sm{font-size:1.75rem;line-height:2.125rem;letter-spacing:-.5px;}
        .txt-button-lg{font-size:1.25rem;line-height:1.5rem;}
    }
    .text-align-inherit{text-align:inherit;}
    .zb-sticky-bottom{position:fixed;bottom:20px;left:0;right:0;z-index:1000;margin-top:-142px;opacity:1;}
    @media screen and (min-width:600px){

    }
    .has-focus-00-color{color:#fff;}
    .zb-button{border:2px solid transparent;border-radius:16px;cursor:pointer;padding:15px 25px;text-align:center;text-decoration:none;transition-duration:.4s;width:100%;display:inline-flex;align-items:center;justify-content:center;-moz-column-gap:16px;column-gap:16px;}
    .zb-button:active,.zb-button:focus{box-shadow:none;outline:0;transform:scale(.98);}
    .zb-button:disabled{cursor:not-allowed;}
    .zb-button.button-growth.button-primary{background-color:rgb(0, 193, 207);border-color:rgb(0, 193, 207);color:#000000;}
    .zb-button.button-growth.button-primary:visited{background-color:rgb(0, 193, 207);border-color:rgb(0, 193, 207);}
    @media (hover:hover){
        .zb-button.button-growth.button-primary:hover{background-color:rgb(3 148 159);border-color:rgb(3 148 159);}
    }
    .zb-button.button-growth.button-primary:focus{background-color:rgb(3 148 159);border-color:rgb(3 148 159);}
    .zb-button.button-growth.button-primary:active{box-shadow:none;background-color:rgb(0, 193, 207);border-color:rgb(0, 193, 207);}
    .zb-button.button-growth.button-primary:disabled{background-color:#C7C7C7;border-color:#C7C7C7;}
    @media screen and (min-width:960px){
        .zb-button{max-width:100%;width:auto;}
    }
    .lg_txt-title-sm,.sm_txt-body-md,.txt-button-lg{font-family:"Inter","Trebuchet_MS",sans-serif;}
    .txt-button-lg{font-weight:600;}
    @media screen and (min-width:960px){
        .lg_txt-title-sm{font-weight:400;}
    }
    @media screen and (max-width:959px){
        .sm_txt-body-md{font-weight:400;}
    }
    .txt-bold{font-weight:600;}
    @media screen and (max-width:959px){
        .sm_txt-body-md{font-size:.9375rem;line-height:1.4375rem;}
        .txt-button-lg{font-size:1rem;line-height:1.25rem;}
    }
    @media screen and (min-width:960px){
        .lg_txt-title-sm{font-size:1.75rem;line-height:2.125rem;letter-spacing:-.5px;}
        .txt-button-lg{font-size:1.25rem;line-height:1.5rem;}
    }
    .text-align-inherit{text-align:inherit;}
    .zb-text{width:100%;margin:0 auto;}
}
/*! CSS Used from: https://www.zenbusiness.com/wp-content/themes/zenbusiness/ui-parts/blocks/cta-banner-v2/cta-banner-v2.css?ver=1685981523 ; media=all */
@media all{
    .zb-cta-banner-v2 .zb-container{display:flex;flex-direction:row;align-items:center;justify-content:center;padding:20px;}
    @media screen and (max-width:599px){
        .zb-cta-banner-v2 .zb-container{flex-direction:column;}
    }
    @media screen and (min-width:600px){
        .zb-cta-banner-v2 .zb-container .title{padding:0 30px;}
    }
    .zb-cta-banner-v2 .zb-container .title p{margin-bottom:0;}
    @media screen and (max-width:599px){
        .zb-cta-banner-v2 .zb-container .title p{margin-bottom:20px;}
    }
    @media screen and (max-width:599px){
        .zb-cta-banner-v2 .zb-container .buttons{width:100%;}
    }
    @media screen and (min-width:600px){
        .zb-cta-banner-v2 .zb-container .buttons{padding:0 30px;}
    }
    .zb-cta-banner-v2 .zb-outer-container{margin:auto;position:relative;}
    .zb-cta-banner-v2 .zb-outer-container.content-width{border-radius:16px;width:calc(100% - 32px);}
    .zb-cta-banner-v2 .zb-outer-container.content-full{max-width:1200px;}
    .zb-cta-banner-v2 .zb-outer-container .close-button{position:absolute;left:0;top:0;padding:16px;font-size:32px;line-height:16px;border:none;background-color:transparent;}
    .zb-cta-banner-v2 .zb-outer-container .close-button.light{color:#fff;}
}
/*! CSS Used from: https://www.zenbusiness.com/wp-content/themes/zenbusiness/assets/css/rebrand.css?ver=1685981523 ; media=all */
@media all{
    .rebrand-2022 .zb-button{border:2px solid transparent;border-radius:16px;cursor:pointer;padding:15px 25px;text-align:center;text-decoration:none;transition-duration:.4s;width:100%;display:inline-flex;align-items:center;justify-content:center;-moz-column-gap:16px;column-gap:16px;}
    .rebrand-2022 .zb-button:active,.rebrand-2022 .zb-button:focus{box-shadow:none;outline:0;transform:scale(.98);}
    .rebrand-2022 .zb-button:disabled{cursor:not-allowed;}
    .rebrand-2022 .zb-button.button-growth.button-primary{background-color:rgb(0, 193, 207);border-color:rgb(0, 193, 207);color:#000000;}
    .rebrand-2022 .zb-button.button-growth.button-primary:visited{background-color:rgb(0, 193, 207);border-color:rgb(0, 193, 207);}
    @media (hover:hover){
        .rebrand-2022 .zb-button.button-growth.button-primary:hover{background-color:rgb(3 148 159);border-color:rgb(3 148 159);}
    }
    .rebrand-2022 .zb-button.button-growth.button-primary:focus{background-color:rgb(3 148 159);border-color:rgb(3 148 159);}
    .rebrand-2022 .zb-button.button-growth.button-primary:active{box-shadow:none;background-color:rgb(0, 193, 207);border-color:rgb(0, 193, 207);}
    .rebrand-2022 .zb-button.button-growth.button-primary:disabled{background-color:#C7C7C7;border-color:#C7C7C7;}
    @media screen and (min-width:960px){
        .rebrand-2022 .zb-button{max-width:100%;width:auto;}
    }
}
</style>
